export const SET_MANAGED_GROUPS = 'SET_MANAGED_GROUPS'
export const SET_SUBSCRIBED_GROUPS = 'SET_SUBSCRIBED_GROUPS'
export const PUSH_MANAGED_GROUPS = 'PUSH_MANAGED_GROUPS'
export const PUSH_SUBSCRIBED_GROUPS = 'PUSH_SUBSCRIBED_GROUPS'

export const OPEN_GROUPS_NAVIGATION = 'OPEN_GROUPS_NAVIGATION'
export const CLOSE_GROUPS_NAVIGATION = 'CLOSE_GROUPS_NAVIGATION'
export const UPDATE_MANAGED_GROUPS_BY_IDS = 'UPDATE_MANAGED_GROUPS_BY_IDS'
export const UPDATE_SUBSCRIBED_GROUPS_BY_IDS = 'UPDATE_SUBSCRIBED_GROUPS_BY_IDS'
export const UPDATE_LATEST_GROUP_TIMESTAMP = 'UPDATE_LATEST_GROUP_TIMESTAMP'